import { render } from "./PasswordResetForm.vue?vue&type=template&id=cd29dbbc&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"

import "./PasswordResetForm.vue?vue&type=style&index=0&id=cd29dbbc&lang=scss&scoped=true"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd29dbbc"]])

export default __exports__